/**
 * @deprecated Use values from ThemeProvider instead.
 * Each property is mapped to its corresponding `theme.core.typography.fontWeight` value.
 */
const FONT_WEIGHTS = {
  /**
   * @deprecated Use `theme.core.typography.fontWeight.light` instead.
   */
  small: 300,

  /**
   * @deprecated Use `theme.core.typography.fontWeight.regular` instead.
   */
  regular: 400,

  /**
   * @deprecated Use `theme.core.typography.fontWeight.medium` instead.
   */
  medium: 500,

  /**
   * @deprecated Use `theme.core.typography.fontWeight.semiBold` instead.
   */
  mediumLarge: 600,

  /**
   * @deprecated Use `theme.core.typography.fontWeight.bold` instead.
   */
  large: 700,
} as const;

export default FONT_WEIGHTS;
